import React, { Component } from "react";
import { Menu } from "semantic-ui-react";
import { connect } from "react-redux";
import {
  updateCloseAppointmentModalVisibility,
  updateCurrentMenu,
  updateGoBackFromCheckoutAndShowModal
} from "../../../actions/menu";
import { Modal } from "semantic-ui-react";
import { forceValidation } from "../validMeReact";
import { saveBooking, updateBooking } from "../../../actions/booking";
import { menuNamesEnum, checkoutModesEnum } from "../../../state/initialState";
import { updateRecurringAppointmentConfirmationModalVisibility } from "../../../actions/menu";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import { updateCheckoutMode } from "../../../actions/checkoutAppointmentStep";

@connect(mapStateToProps)
export default class CloseAppointmentModal extends Component {
  constructor(props) {
    super(props);
  }

  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  handleSaveClick = () => {
    let {
      appointmentStepData,
      advancedAppointmentStepData,
      currentBookingId,
      isMultiServiceAppointment,
      gotValidOffer
    } = this.props;

    let areThereErrors = forceValidation(
      null,
      null,
      "secondStepAdvancedAppointment"
    );
    let areThereErrorsTwo = forceValidation(null, null, "firstStepAppointment");
    let cb = () => {
      let event = new CustomEvent("messageFromUsToParent", {
        detail: {
          action: "refresh"
        }
      });
      window.dispatchEvent(event);
      this.closeApp();
    };
    if (!areThereErrors && !areThereErrorsTwo) {
      if (currentBookingId) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            null,
            null,
            cb,
            isMultiServiceAppointment,
            gotValidOffer
          )
        );
      } else {
        this.props.dispatch(
          saveBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            null,
            null,
            cb,
            isMultiServiceAppointment,
            gotValidOffer
          )
        );
      }
    }
  };

  //TODO REFACTOR OUT THIS FUNCTION ITS NOT REQUIRED
  handleCloseApp = () => {
    let { advancedAppointmentStepData, appointmentStepData } = this.props;
    let {
      currentBookingId,
      advancedAppointmentStepDataFromLastSave,
      loadingBooking
    } = this.props;

    let savedSnapshot = sessionStorage.getItem("BOOKING_APPOINTMENT_SNAPSHOT");
    let currentSnapshot = JSON.stringify({
      appointmentStepData,
      advancedAppointmentStepData
    });
    if (savedSnapshot == currentSnapshot) {
      //if there are no changes, no need to show the modal
      this.closeApp();
    } else {
      if (
        advancedAppointmentStepDataFromLastSave.recurringToggleOn &&
        (currentBookingId || loadingBooking)
      ) {
        //this popup should only be visible whe modifying an existing recurring appointment
        let visibleRecursiveAppointmentModal = true;
        let closeAppWhenRecursiveAppointmentModalCloses = true;
        this.props.dispatch(
          updateRecurringAppointmentConfirmationModalVisibility(
            visibleRecursiveAppointmentModal,
            closeAppWhenRecursiveAppointmentModalCloses
          )
        );
      } else {
        let visibleCloseAppointmentModal = true;
        this.props.dispatch(
          updateCloseAppointmentModalVisibility(visibleCloseAppointmentModal)
        );
      }
    }
  };

  handleCloseCheckout = () => {
    const { invoiceData } = this.props;
    if (!invoiceData.key) {
      this.handleCloseApp();
    } else {
      if (invoiceData.status == "PAID" || invoiceData.balanceamount > 0) {
        this.closeApp();
      } else {
        this.props.dispatch(updateCloseAppointmentModalVisibility(true));
      }
    }
  };

  handleGoBackFromCheckout = () => {
    this.props.dispatch(updateCurrentMenu(this.props.checkoutPreviousMenu));
    this.props.dispatch(updateGlobalErrorMessage("")); //remove all checkout related errors
    this.props.dispatch(updateGoBackFromCheckoutAndShowModal(false));
    this.props.dispatch(updateCheckoutMode(checkoutModesEnum.VIEW_MODE));
  };

  getCloseAppointmentModal = () => {
    let {
      closeAppointmentModalVisible,
      savingBooking,
      currentMenu,
      goBackFromCheckout,
      globalErrorMessage
    } = this.props;
    let {
      No,
      Yes,
      Ok,
      SaveChangesCloseModal,
      DiscardChanges
    } = window.APP.LANGUAGE.Shared.PopupWindows;
    const {
      CancelCheckoutTitle,
      CancelCheckoutSubtitle,
      CancelCheckoutConfirm,
      CancelCheckoutCancel
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

    let canWeActuallySave = true;
    if (window.validMeReact) {
      try {
        canWeActuallySave = !window.validMeReact.validMeManager.areThereErrors(
          "firstStepAppointment&secondStepAdvancedAppointment"
        );
      } catch (ex) {}
    }
    if (
      canWeActuallySave &&
      (currentMenu == menuNamesEnum.FIRST_STEP_APPOINTMENT ||
        currentMenu == menuNamesEnum.SECOND_STEP_ADVANCED)
    ) {
      canWeActuallySave = !globalErrorMessage; //convert nulls and undefined and empty into true value and then into false
    }
    let handleCancel = () => {
      let visible = false;
      this.props.dispatch(updateCloseAppointmentModalVisibility(visible));
    };

    let discardButtonClasses = "ui button cancel-btn";
    let saveClasses = "ui button savebtn";
    if (savingBooking) {
      saveClasses += " loading disabled";
    }

    let checkoutContent = "";
    let nonCheckoutContent = "";
    if (canWeActuallySave) {
      if (currentMenu == menuNamesEnum.THIRD_STEP_CHECKOUT) {
        checkoutContent = (
          <div className="save-box">
            <section className="header">
              <button
                type="button"
                className="close_button"
                onClick={handleCancel}
              ></button>
              {CancelCheckoutTitle}
              <p className="save_text">{CancelCheckoutSubtitle}</p>
            </section>
            <section className="save_box_buttons">
              <div className="ui button cancel_btn" onClick={handleCancel}>
                {CancelCheckoutCancel}
              </div>
              <div
                className="ui button send_btn"
                onClick={
                  goBackFromCheckout
                    ? this.handleGoBackFromCheckout
                    : this.closeApp
                }
              >
                {CancelCheckoutConfirm}
              </div>
            </section>
          </div>
        );
      } else {
        nonCheckoutContent = (
          <div className="save-box">
            <section className="header">
              {SaveChangesCloseModal}
              <button
                type="button"
                className="close_button"
                onClick={handleCancel}
              ></button>
            </section>
            <section className="save_box_buttons">
              <div
                className="ui button cancel-btn"
                onClick={() => this.closeApp()}
              >
                {No}
              </div>
              <div className={saveClasses} onClick={this.handleSaveClick}>
                {Yes}
              </div>
            </section>
          </div>
        );
      }
    } else {
      if (currentMenu == menuNamesEnum.THIRD_STEP_CHECKOUT) {
        checkoutContent = (
          <div className="save-box">
            <section className="header">
              <button
                type="button"
                className="close_button"
                onClick={handleCancel}
              ></button>
              {CancelCheckoutTitle}
              <p className="save_text">{CancelCheckoutSubtitle}</p>
            </section>
            <section className="save_box_buttons">
              <div className="ui button cancel_btn" onClick={handleCancel}>
                {CancelCheckoutCancel}
              </div>
              <div
                className="ui button send_btn"
                onClick={
                  goBackFromCheckout
                    ? this.handleGoBackFromCheckout
                    : this.closeApp
                }
              >
                {CancelCheckoutConfirm}
              </div>
            </section>
          </div>
        );
      } else {
        nonCheckoutContent = (
          <div className="save-box">
            <section className="header">
              {DiscardChanges}
              <button
                type="button"
                className="close_button"
                onClick={handleCancel}
              ></button>
            </section>
            <section className="save_box_buttons">
              <div
                className={discardButtonClasses + " discard-button"}
                onClick={this.closeApp}
              >
                {Ok}
              </div>
            </section>
          </div>
        );
      }
    }
    let getCloseDialog = () => {
      if (currentMenu == menuNamesEnum.THIRD_STEP_CHECKOUT) {
        return (
          <Modal.Content className="modal_popup transparent-bg">
            <div className="modal_overlay"></div>
            {checkoutContent}
          </Modal.Content>
        );
      } else {
        return (
          <Modal.Content className="tip_popup transparent-bg">
            <div className="tip_overlay"></div>
            {nonCheckoutContent}
          </Modal.Content>
        );
      }
    };
    if (!closeAppointmentModalVisible) {
      return "";
    }

    return (
      <Modal
        className="bookingdetails-model discard-changes-modal transparent-bg no-borders"
        open={true}
      >
        {getCloseDialog()}
      </Modal>
    );
  };

  render() {
    return this.getCloseAppointmentModal();
  }
}
function mapStateToProps(state) {
  return {
    closeAppointmentModalVisible:
      state.menuReducer.closeAppointmentModalVisible,
    goBackFromCheckout: state.menuReducer.goBackFromCheckout,
    savingBooking: state.bookingReducer.savingBooking,
    currentMenu: state.menuReducer.currentMenu,
    loadingBooking: state.bookingReducer.loadingBooking,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    globalErrorMessage: state.globalErrorReducer.message,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    checkoutPreviousMenu: state.menuReducer.checkoutPreviousMenu,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    currentBookingId: state.bookingReducer.currentBookingId,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    invoiceData: state.appointmentCheckoutReducer.invoiceData
  };
}
